import TotpDialog from "@/components/Totp.vue";
import { computed, ref } from "vue";
import { useDialog } from "primevue/usedialog";
import type { DynamicDialogInstance } from "primevue/dynamicdialogoptions";
import { until } from "@vueuse/core";

export const useTotpDialog = () => {
    const dialog = useDialog();
    const dialogRef = ref<DynamicDialogInstance & { visible?: boolean }>();
    const isVisible = computed(() => Boolean(dialogRef.value?.visible));
    const authenticationSuccess = ref(false);

    /**
     * Opens dialog and returns when the dialog is closed with
     * the authenticationSuccess value.
     */
    const open = async (
        {
            enrollment,
            successCallback,
            failureCallback,
        }: {
            enrollment?: boolean;
            successCallback?: () => void;
            failureCallback?: () => void;
        } = {
            enrollment: false,
        }
    ) => {
        dialogRef.value = dialog.open(TotpDialog, {
            props: {
                header: "One-Time Password",
                style: {
                    maxWidth: "600px",
                    width: "80%",
                },
                modal: true,
                maximizable: false,
                draggable: false,
            },
            data: {
                enrollment,
                failureCallback: () => {
                    authenticationSuccess.value = false;
                    failureCallback?.();
                },
                successCallback: () => {
                    authenticationSuccess.value = true;
                    successCallback?.();
                },
            },
        });

        await until(isVisible).not.toBeTruthy();
        return authenticationSuccess.value;
    };

    return { open, isVisible };
};
